import * as React from "react";
import {cx} from "emotion";

import "./info-block.scss";

import {cs} from "@Common/react/chain-services";

export const InfoBlock = ({type="info", content, className=undefined, onClose = undefined, xdQaName=undefined, domRef=undefined}) => cs(
    () => (
        <div className={cx("info-block info-block-40r", className, type, {closable: onClose})} ref={domRef}>
            <div className="icon" xd-qa-type="icon" xd-qa-name={xdQaName}>
                {type === "info" ? (
                    <div className="circle">
                        <i className="fa fa-info"/>
                    </div>
                ) : type === "warning" && (
                    <i className="fa fa-warning"/>
                )}
            </div>
            <div className="content">
                <div className="text" xd-qa-type="label" xd-qa-name={xdQaName}>
                    {content}
                </div>

                {onClose && (
                    <div className="close" onClick={onClose} xd-qa-type="icon" xd-qa-name={"Close " + xdQaName}>
                        &times;
                    </div>
                )}
            </div>

        </div>
    ),
);
